const fetch = require('node-fetch');

const apiKey = process.env.REACT_APP_API_BASE_KEY;

const getHeaders = () => {
  return {
    'Authorization': `Bearer ${apiKey}`,
    'Content-Type': 'application/json'
  };
};

export const fetchApi = (url, options) => {
  const headers = getHeaders();
  if (options && options.headers) {
    Object.assign(headers, options.headers);
    delete options.headers;
  }

  return fetch(url, { ...options, headers })
    .then(response => {
      if (response.ok) {
        return response;
      } else {
        throw new Error('Failed to fetch data');
      }
    })
    .catch(error => {
      console.error(error);
    });
};

export default fetchApi;